import Vue from 'vue'
import store from '../store'
import {get} from 'lodash'
import {getDefaultFormattedMoney} from '@/utils/currency'

Vue.filter('teamCurrency', amount => {
    let symbol = '$'
    if (get(store, 'getters.activeTeam.currency.symbol')) {
        symbol = store.getters.activeTeam.currency.symbol
    }
    return getDefaultFormattedMoney(amount, symbol)
})

Vue.filter('snippet', (value, cnt) => {
    if (!value) {
        return ''
    }
    value = value.toString()
    return value.length > cnt ? value.substring(0, cnt) + ' ...' : value
})

Vue.filter('capitalize', (value) => {
    if (!value) return ''
    value = value.toString()
    return value.charAt(0).toUpperCase() + value.slice(1)
})

Vue.filter('json', (value) => JSON.stringify(value, null, 2))

Vue.filter('highlightSearch', (text, query, caseSensitive = true) => {
    let idx
    if (caseSensitive) {
        idx = text.indexOf(query)
    } else {
        idx = text.toLowerCase().indexOf(query.toLowerCase())
    }
    if (idx >= 0) {
        return `${text.substring(0, idx)}<span class="highlight-search">${text.substring(idx, idx + query.length)}</span>${text.substring(idx + query.length)}`
    } else {
        return text
    }
})

Vue.filter('awsExecutionTime', seconds => {
    seconds = Number(seconds)
    if (!_.isNumber(seconds)) {
        return '-'
    }
    if (seconds < 1) {
        return Math.floor(seconds * 1000) + 'ms'
    }
    return seconds.toFixed(2) + 's'
})

Vue.filter('pluralize', (word, amount) => amount > 1 ? `${word}s` : word)
